var indentation_default = {
  "indentZero": "VY8Cq",
  "indentOne": "ycA5o",
  "indentTwo": "_2lBn-",
  "indentThree": "vwqka",
  "indentFour": "bxSco",
  "indentFive": "yUeb1",
  "indentSix": "gQraF"
};
export {
  indentation_default as default
};
//# sourceMappingURL=indentation-scss.js.map
